export default "<!DOCTYPE html>\n<html>\n<head>\n    <title></title>\n\t<meta charset=\"utf-8\" />\n</head>\n<body>\n\n</body>\n</html>\n";